import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SessionActivityDataForm } from '../../_models/session-activity-data-form';
import { MatStepper } from '@angular/material';
import { SesssionActivityService } from '../../_services/sesssion-activity.service';
import { Router } from '@angular/router';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { LearningStatusService } from 'src/app/_services/learning-status.service';

@Component({
  selector: 'app-learning-filing',
  templateUrl: './learning-filing.component.html',
  styleUrls: ['./learning-filing.component.css']
})

export class LearningFilingComponent implements OnInit {
  message: string;
  navItemSelected: string = '';
  learningTitle: string = '';
  userDataSession;
  userDetailsId = 0;
  nda = 0;
  stepperIndex: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();
  sessionActivity;

  @ViewChild('stepper') stepper: MatStepper;
  staticdata: string;

  constructor(private router: Router,
    private sesssionActivityService: SesssionActivityService,
    private successDialogService: SuccessDialogService,
    private learningStatusService: LearningStatusService
  ) { }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
      this.nda = this.userDataSession.nda;
    }
    this.getLastSessionAcgtivityBYUserId(this.userDetailsId, 5);
  }

  getLastSessionAcgtivityBYUserId(userDetailId, activityType) {
    this.sesssionActivityService.getLastSessionActiityByUserId(userDetailId, activityType).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                setTimeout(() => {
                  this.stepper.selectedIndex = step.index;
                });
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  isSeenFirst = false;
  isSeenSecond = false;
  isSeenThird = false;
  isSeenFour = false;
  isSeenFive = false;
  isSeenSix = false;
  isSeenSeven = false;
  isSeenEight = false;

  moveNextIndex() {
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.activityType = 5
    const currentUser = localStorage.getItem('currentUser');
    this.sessionActivityDataForm.userDetails = JSON.parse(currentUser);
    switch (indexNumber) {
      case (2):
        if (!this.isSeenSecond) {
          this.isSeenSecond = true;
          this.sessionActivityDataForm.lastActivitySession = 2;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (3):
        if (!this.isSeenThird) {
          this.isSeenThird = true;
          this.sessionActivityDataForm.lastActivitySession = 3;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (4):
        if (!this.isSeenFour) {
          this.isSeenFour = true;
          this.sessionActivityDataForm.lastActivitySession = 4;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (5):
        if (!this.isSeenFive) {
          this.isSeenFive = true;
          this.sessionActivityDataForm.lastActivitySession = 5;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (6):
        if (!this.isSeenSix) {
          this.isSeenSix = true;
          this.sessionActivityDataForm.lastActivitySession = 6;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      default:
        break;
    }
  }

  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = " Basic type of patent filing in India";
        break;
      case 2:
        this.message = " Other types of patent filing";
        break;
      case 3:
        this.message = "Forms in Indian Patent office";
        break;
      case 4:
        this.message = "Forms required for submitting Provisional Patent Application";
        break;
      case 5:
        this.message = "Forms required for submitting Complete Patent Application";
        break;
      case 6:
        this.message = "Other Types Of Patent Application";
        break;
      default:
        break;
    }
  }

  goToBasicinvention() {
    this.learningStatusService.getLearningSatatus(this.userDataSession.userDetailsId);
    if (this.nda === 0) {
      this.successDialogService.successDialog(5);
    } else {
      this.router.navigate(['/main/basicInventionDetails']);
    }
  }
}
